export const STAT_TYPES = {
  BATTING: "batting",
  PITCHING: "pitching",
  LINEUP: "lineup",
  BULLPEN: "bullpen",
  ROSTER: "roster",
  GAMES: "games",
  VALUE_BATTING: "value_batting_team",
  VALUE_PITCHING: "value_pitching_team",
  SITUATIONAL_BATTING: "situational_batting_team",
  SITUATIONAL_PITCHING: "situational_pitching_team",
  SPLITS_BATTING: "splits_batting_team",
  SPLITS_PITCHING: "splits_pitching_team",
  BATTED_BALL_BATTING: "batted_ball_batting_team",
  BATTED_BALL_PITCHING: "batted_ball_pitching_team",
  BASERUNNING: "baserunning_team",
};

export const EXTRA_STAT_TYPES = [
  STAT_TYPES.VALUE_BATTING,
  STAT_TYPES.VALUE_PITCHING,
  STAT_TYPES.SITUATIONAL_BATTING,
  STAT_TYPES.SITUATIONAL_PITCHING,
  STAT_TYPES.SPLITS_BATTING,
  STAT_TYPES.SPLITS_PITCHING,
  STAT_TYPES.BATTED_BALL_BATTING,
  STAT_TYPES.BATTED_BALL_PITCHING,
  STAT_TYPES.BASERUNNING,
];
